export const CHECK_SUPPLY_INIT = 'CHECK_SUPPLY_INIT'
export const CHECK_SUPPLY_SUCCESS = 'CHECK_SUPPLY_SUCCESS'
export const CHECK_SUPPLY_ERROR = 'CHECK_SUPPLY_ERROR'
